import {
  OUT_OF_STOCK,
  OUT_OF_ADDITIONAL_STOCK
} from "../../../../../services/bag/constants";
import { SET_VARIANT_OUT_OF_STOCK } from "../../constants";
import { findErrorsInMessages } from "./findErrorsInMessages";

export const updateStockIndicationIfNecessary = ({
  dispatch,
  e: { message },
  id
}) => {
  const { errorCode } =
    findErrorsInMessages({
      messages: [].concat(message),
      bagErrorCodes: [OUT_OF_STOCK, OUT_OF_ADDITIONAL_STOCK]
    }) || {};
  if (errorCode) {
    dispatch({
      type: SET_VARIANT_OUT_OF_STOCK,
      payload: { id }
    });
  }
};
